module.exports = __webpack_public_path__ + "static/media/68.63068e59.jpg";